module.exports = __webpack_public_path__ + "img/active-state.0d82cc9c.svg";